import { SelectionMultipleMarkerIcon } from './SelectionMultipleMarkerIcon';

/**
 * author: Austin Andrews
 * id 5B06BC81-DA70-41F2-B05C-31E9BD7F571E
 * name selection-multiple-marker
 * version: 4.7.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/selection-multiple-marker.svg
 * tags
 * - Navigation 
 */
export const SelectionMultipleLocationIcon = SelectionMultipleMarkerIcon;
export default SelectionMultipleLocationIcon